export default __webpack_public_path__ + "static/media/logo.375fe7dc.svg";